module.exports = __webpack_public_path__ + "static/media/17UN-Women2.d3dd3587.jpg";